import { Button, Tooltip, Avatar } from "antd";
import {
  MessageOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  VideoCameraOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ChatHeader({ selectedChat }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="d-flex align-items-center justify-content-between w-100 px-4 py-3 bg-white border-bottom shadow-sm"
    >
      {/* Left: Chat Info */}
      <div className="d-flex align-items-center gap-3 cursor-pointer">
        <div className="position-relative">
          {selectedChat?.avatar ? (
            <Avatar size="large" src={selectedChat.avatar} />
          ) : (
            <Avatar size="large">
              {selectedChat?.name
                ?.split(" ")
                .map((word) => word[0])
                .join("")
                .toUpperCase()
                .slice(0, 2)}
            </Avatar>
          )}
        </div>
        <div className="d-flex flex-column">
          <div className="fw-semibold fs-6 text-dark">
            {selectedChat ? selectedChat.name : "Select a chat"}
          </div>
          {selectedChat && <div className="text-success small">Online</div>}
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.3); opacity: 0.6; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </motion.div>
  );
}
